module.exports = __webpack_public_path__ + "static/media/AnyAbnormalSleep.0b6b7303.png";